function initAutoplayVideos() {
	const containers = document.querySelectorAll<HTMLElement>('.video-inline');

	containers.forEach((container) => {
		const iframe = container.querySelector<HTMLIFrameElement>('iframe');
		if (!iframe || iframe.classList.contains('playing')) {
			return;
		}

		if (!window.Vimeo?.Player) {
			return;
		}

		const videoId = container.id;
		const parentEl = container.parentElement;
		const pauseBtn = document.querySelector<HTMLElement>(
			`.video-inline__pause[data-video-id="${videoId}"]`
		);
		const playBtn = document.querySelector<HTMLElement>(
			`.video-inline__play[data-video-id="${videoId}"]`
		);

		const player = new window.Vimeo.Player(iframe);

		player.on('play', () => {
			iframe.classList.add('playing');
			pauseBtn?.classList.add('is-active');
			parentEl?.classList.add('is-playing');
		});

		player.getPaused().then((paused) => {
			if (!paused) {
				iframe.classList.add('playing');
				pauseBtn?.classList.add('is-active');
				parentEl?.classList.add('is-playing');
			}
		});

		if (pauseBtn && playBtn) {
			pauseBtn.addEventListener('click', () => {
				player.pause();
				pauseBtn.classList.remove('is-active');
				playBtn.classList.add('is-active');
			});

			playBtn.addEventListener('click', () => {
				player.play();
				playBtn.classList.remove('is-active');
				pauseBtn.classList.add('is-active');
			});
		}
	});
}

window.addEventListener('load', initAutoplayVideos);
window.addEventListener('rocket-allScriptsLoaded', initAutoplayVideos);
